import { CUSTOM_PERIOD, REPORT_PERIODS } from "../utils/reportPeriods";

function ReportFilters({
  reportPeriod,
  setReportPeriod,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  accountingMethod,
  setAccountingMethod,
}) {
  // Typing a date by hand means the named period no longer describes the
  // range, so the dropdown follows the user over to "Custom"
  const editDate = (setter) => (e) => {
    setter(e.target.value);
    if (reportPeriod !== CUSTOM_PERIOD) setReportPeriod(CUSTOM_PERIOD);
  };

  return (
    <div className="report-filters-bar">
      <div className="filter-item">
        <label>Report period</label>
        <select
          value={reportPeriod}
          onChange={(e) => setReportPeriod(e.target.value)}
        >
          {REPORT_PERIODS.map((p) => (
            <option key={p.key} value={p.key}>
              {p.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-item">
        <label>From</label>
        <input type="date" value={startDate} onChange={editDate(setStartDate)} />
      </div>

      <div className="filter-item">
        <label>To</label>
        <input type="date" value={endDate} onChange={editDate(setEndDate)} />
      </div>

      <div className="filter-item">
        <label>Accounting method</label>
        <select
          value={accountingMethod}
          onChange={(e) => setAccountingMethod(e.target.value)}
        >
          <option value="accrual">Accrual</option>
          <option value="cash">Cash</option>
        </select>
      </div>
    </div>
  );
}

export default ReportFilters;
